import { Block } from "./types";
import { INITIAL_BLOCKS } from "./blocks";

// Simple BlockRegistry factory
export class BlockRegistry {
  private static registry: Record<string, Block> = INITIAL_BLOCKS;

  public static getBlock(blockId: string): Block {
    return BlockRegistry.registry[blockId];
  }

  public static getAllBlocks(): Block[] {
    return Object.values(BlockRegistry.registry);
  }

  public static registerBlock(block: Block): void {
    BlockRegistry.registry = { ...BlockRegistry.registry, [block.id]: block };
  }

  public static unregisterBlock(blockId: string): void {
    const { [blockId]: _, ...rest } = BlockRegistry.registry;
    BlockRegistry.registry = rest;
  }
}

// Helper function to register a block (can be used in React components)
export function registerBlock(block: Block) {
  BlockRegistry.registerBlock(block);
}
